import React from 'react';
import Hero from '../components/Hero';
import Weddings from '../components/Weddings';
import Catering from '../components/Catering';
import Amenities from '../components/Amenities';
import Contact from '../components/Contact';
import Testimonials from '../components/Testimonials';
import AiSnapshot from '../components/AiSnapshot';
import SeoMeta from '../components/SeoMeta';
import AminosInlineChat from '../components/AminosInlineChat';

const HomePage = () => (
  <main>
    <SeoMeta
      title="Wedding Venue in Claremont,CA | Padua Weddings"
      description="Explore a historic Spanish Revival wedding venue in Claremont with outdoor ceremony spaces,an indoor ballroom and in-house catering. Book a private tour."
    />
    <Hero />
    <AminosInlineChat />
    <Weddings />
    <Catering />
    <Amenities />
    <Contact />
    <Testimonials />
    <AiSnapshot
      data={{ venueType: 'Historic Spanish Revival Wedding Venue & Private Estate' }}
      visuallyHidden={true}
    />
  </main>
);

export default HomePage;